import type {
    DetectLanguageRequest,
    DetectLanguageResponse,
    TranslateTextRequest,
    TranslateTextResponse,
} from './types/language';

/**
 * 语言服务 API 接口
 * @description 提供语言检测和翻译功能，可被多个域共享使用
 */
export interface LanguageApi {
    /**
     * 检测输入文本的语言
     * @param data 语言检测请求参数
     * @returns 检测到的语言类型
     */
    detectLanguage(data: DetectLanguageRequest): Promise<DetectLanguageResponse>;

    /**
     * 翻译文本
     * @param data 翻译请求参数
     * @returns 翻译后的文本
     */
    translateText(data: TranslateTextRequest): Promise<TranslateTextResponse>;
}

/**
 * LanguageApi 的 IOC 注入标识符
 */
export const LanguageApi = Symbol('LanguageApi');
